
import React from 'react';

const RejectedAccountCard: React.FC = () => {
  return (
    <div className="bg-red-50 p-6 rounded-lg border border-red-100 mb-6">
      <h2 className="text-xl font-semibold text-red-800 mb-2">Account Access Denied</h2>
      <p className="text-red-700 mb-4">
        Your account access request has been reviewed and was not approved at this time.
        Please contact our support team if you believe this is an error.
      </p>
    </div>
  );
};

export default RejectedAccountCard;
